import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IExecutionSet, ITestStepRun, ItTestCaseRun, ItestStepDetailDefect } from './Execute.type';
import { getSettingAPI } from 'app/services/api/bug';

export interface ExecuteState {
  isUpdateTestCase: boolean;
  isReloadAssignedExecution: boolean;
  isReloadSelectedExecutionCycle: boolean;
  executionSetId: number;
  executionSetRunId: number;
  execuTetestCaseId: number;
  testCaseRunId: number;
  testCaseDetail: ItTestCaseRun;
  testCaseDetailTitle: string;
  testStepId: number;
  testStepRunId: number;
  testStepDetailDefect: ItestStepDetailDefect;
  filterYourAssignedExecution: any;
  selectedExecutionSet: any;
  isUpdateTestStepDefect: boolean;
  testCaseStep: ITestStepRun;
  listExecutionCycles: any;
  listTestCaseSteps: any;
  filterAssignedExecution: boolean;
}
const initialState: ExecuteState = {
  isUpdateTestCase: false,
  isReloadAssignedExecution: false,
  isReloadSelectedExecutionCycle: false,
  executionSetId: 0,
  executionSetRunId: 0,
  execuTetestCaseId: 0,
  testCaseRunId: 0,
  testCaseDetail: {} as Required<ItTestCaseRun>,
  testCaseDetailTitle: '',
  testStepId: 0,
  testStepRunId: 0,
  testStepDetailDefect: {} as Required<ItestStepDetailDefect>,
  filterYourAssignedExecution: [],
  selectedExecutionSet: {},
  isUpdateTestStepDefect: false,
  testCaseStep: {} as Required<ITestStepRun>,
  listExecutionCycles: [],
  listTestCaseSteps: [],
  filterAssignedExecution: true,
};

export const getSetting = createAsyncThunk('release/getSetting', async () => {
  const response = await getSettingAPI();
  return response;
});

export const executeSlice = createSlice({
  name: 'execute',
  initialState,

  reducers: {
    triggerIsUpdateTestCase: state => {
      state.isUpdateTestCase = !state.isUpdateTestCase;
    },
    triggerIsReloadAssignedExecution: state => {
      state.isReloadAssignedExecution = !state.isReloadAssignedExecution;
    },
    triggerIsReloadSelectedExecutionCycle: state => {
      state.isReloadSelectedExecutionCycle = !state.isReloadAssignedExecution;
    },
    setExecutionSetId: (state, action) => {
      state.executionSetId = action.payload;
    },
    setExecutionSetRunId: (state, action) => {
      state.executionSetRunId = action.payload;
    },
    setExecuteTestCaseId: (state, action) => {
      state.execuTetestCaseId = action.payload;
    },
    setTestCaseRunId: (state, action) => {
      state.testCaseRunId = action.payload;
    },
    settestCaseDetail: (state, action) => {
      state.testCaseDetail = action.payload;
    },
    setSelectedExecutionSet: (state, action) => {
      state.selectedExecutionSet = action.payload;
    },
    setTestStepId: (state, action) => {
      state.testStepId = action.payload;
    },
    setFilterYourAssignedExecution: (state, action) => {
      state.filterYourAssignedExecution = action.payload;
    },
    setFilterAssignedExecution: (state, action) => {
      state.filterAssignedExecution = action.payload;
    },
    setTestStepRunId: (state, action) => {
      state.testStepRunId = action.payload;
    },
    setTestStepDetailDefect: (state, action) => {
      state.testStepDetailDefect = action.payload;
    },
    setTestCaseStep: (state, action) => {
      state.testCaseStep = action.payload;
    },
    setListExecutionCycles: (state, action) => {
      state.listExecutionCycles = action.payload;
    },
    setListTestCaseSteps: (state, action) => {
      state.listTestCaseSteps = action.payload;
    },
    clearTestStepDetailDefect: state => {
      state.testStepDetailDefect = initialState.testStepDetailDefect;
    },
    triggerIsUpdateTestStepDefect: state => {
      state.isUpdateTestStepDefect = !state.isUpdateTestStepDefect;
    },
  },
  extraReducers: builder => {},
});

export const {
  setListExecutionCycles,
  setListTestCaseSteps,
  triggerIsUpdateTestCase,
  triggerIsReloadAssignedExecution,
  triggerIsReloadSelectedExecutionCycle,
  setExecutionSetId,
  setExecutionSetRunId,
  setTestCaseRunId,
  setExecuteTestCaseId,
  settestCaseDetail,
  setSelectedExecutionSet,
  setTestStepId,
  setTestCaseStep,
  setFilterYourAssignedExecution,
  setFilterAssignedExecution,
  setTestStepRunId,
  setTestStepDetailDefect,
  clearTestStepDetailDefect,
  triggerIsUpdateTestStepDefect,
} = executeSlice.actions;

export default executeSlice.reducer;
